module.exports = __webpack_public_path__ + "media/navigation/icon-dog-profile-e4c755bb.svg";